export class ExpenditureCategory {
  public id?: string;
  public name: string;
}
